import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ChannelUserFragmentDoc } from './ChannelUser';
export type ChannelFragment = { id: string, name: string, icon?: string | null, accessType: Types.ChannelAccessTypeEnum, description?: string | null, createdAt: string, allowedToPost?: Types.ChannelAllowedToPostEnum | null, topic: string, channelUser?: { id: string, lastViewedAt: string, unreadCount?: number | null } | null, userPermissions: Array<{ action: Types.ChannelActionsEnum, subject: Types.ChannelSubjectsEnum }> };


export type ChannelFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ChannelFragmentDoc = /*#__PURE__*/ gql`
    fragment Channel on ChannelType {
  id
  name
  icon
  accessType
  description
  createdAt
  channelUser {
    ...ChannelUser
  }
  userPermissions {
    action
    subject
  }
  allowedToPost
  topic
}
    `;